<script lang="ts">
	//Event dispatcher
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from '../../../../services/i18n';
	//Design system components
	import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';
	import { Select } from '@Shelly/shelly-design-system';
	import { modeTypes } from './schedules';

	const dispatch = createEventDispatcher();

	export let mode = modeTypes.time;

	let options: SelectOptionPropsType[] = [
		{
			title: $format('schedule_opt_time', { default: 'Specific time' }),
			value: modeTypes.time,
		},
		{
			title: `${$format('schedule_opt_sunrise')} / ${$format('schedule_opt_sunset')}`,
			value: modeTypes.sunrise,
		},
	];

	let value: SelectOptionPropsType = options[0]; //Default options

	$: value = mode !== modeTypes.time ? options[1] : options[0];

	const handleChange = (e: CustomEvent) => {
		value = e.detail;
		dispatch('change', e.detail.value);
	};
</script>

<Select
	size="m"
	class="mb-m"
	{value}
	{options}
	icon="fas fa-clock"
	on:change={handleChange}
	aria-label={$format('schedule_type_selector', { default: 'Type selector' })}
	id="select-ny5h4dq"
/>
